import React from "react";

import { ProductsQuery } from "../../../../../../../queries/products/components/ProductsQuery";
import { RESULTS_PER_PAGE } from "./constants";
import { ProductsContext } from "./context";
import { useFilterParams, usePage } from "./hooks";

const ProductsContextProvider: React.FC = ({ children }) => {
  const page = usePage();
  const filterParams = useFilterParams();
  return (
    <ProductsQuery filters={filterParams} page={page - 1} count={RESULTS_PER_PAGE}>
      {({ error, loading, data }) => {
        if (error) {
          throw error;
        }
        const productsData = Boolean(data) && Boolean(data!.productList) ? data!.productList : {};
        return (
          <ProductsContext.Provider value={{ loading, page, ...productsData }}>
            {children}
          </ProductsContext.Provider>
        );
      }}
    </ProductsQuery>
  );
};

export { ProductsContextProvider };
